import React from 'react';
import logo from './logo.svg';
import './App.css';
import Index from './components/Index'


function App() {
  return <Index />

}

export default App;
